<template>
  <div class="problem-cache-container" id="outermost">
    <van-nav-bar
      title="暂存问题"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />
    <div v-if="!list.length" style="text-align: center; color: #aaa">
      <van-empty description="无暂存问题" />
    </div>
    <div v-else class="problem-box">
      <div v-for="(i, index) in list" :key="i.id" class="problem-panel">
        <van-button @click="submitProblem(i.id, index)" :loading="loadings[index]" color="#1B75F6" size="small" style="float: right;">提交</van-button>
        <p>问题类型： {{ i.problemTypeName }}</p>
        <p>问题子类： {{ i.problemSubclass }}</p>
        <p>问题等级： {{ i.problemLevelName }}</p>
        <p>问题描述： {{ i.problemDescription }}</p>
        <p>整改建议： {{ i.suggestions }}</p>
<!--        <p>是否存在商机： {{ i.opportunity === '1'? '是' : '否' }}</p>-->
        <p v-if="i.problemPhotoFiles">
          <van-image v-for="(c, i) of i.problemPhotoFiles" @click="clickImage(c.src)" :key="i" width="50" height="50" :src="c.url" style="margin-right: 10px"/>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview, Toast } from 'vant'
import { dataURLtoFile } from '@/libs/coverter'
import $ from '@/fly'
import { ProblemStore } from '@/libs/indexedDB'
export default {
  name: "problemCache",
  data() {
    return {
      list: [],
      loadings: []
    }
  },
  methods: {
    async submitProblem(id, index) {
      this.$set(this.loadings, index, true)
      {
        const problem = await ProblemStore.get(id)
        const {problemPhotoFiles} = problem
        let aIds = []
        if (problemPhotoFiles && problemPhotoFiles.length)
          aIds = await $.multiUpload(problemPhotoFiles.map(f => dataURLtoFile(f.url, f.filename)))
        await $.post('problem',
          JSON.stringify([{...problem, problemPhotoFiles: null, problemPhotos: aIds.join(',')}]),
          {contentType: 'application/json'}
        ).catch(err => Toast.fail(err.message))
        await ProblemStore.delete(id)
        this.list.splice(this.list.findIndex(p => p.id === id), 1)
        Toast.success('提交成功！')
      }
      this.loadings.splice(index, 1)
    },
    clickImage(src) {
      ImagePreview({ images: [src], closeable: true })
    }
  },
  async created() {
    this.list = (await ProblemStore.toArray()).sort((f, s) => s.id - f.id)
    this.loadings = this.list.map(() => false)
  }
}
</script>
<style lang="less" scoped>
.problem-cache-container {
  height: 100vh;
  background: #f7f7f7;
  .problem-box {
    padding: 10px 20px 20px 20px;
    .problem-panel {
      background-color: #FFFFFF;
      margin-top: 20px;
      padding: 20px 30px;
      font-size: 28px;
      p {
        margin-top: 15px;
      }
    }
  }
}

</style>
